module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/pickup-1-4d5222cc906ee74add56cf79eb83272a.png";